import { useEffect, useState } from "react";
import { useScreenDetector } from "../utils/useScreenSize";
import posthog from "posthog-js";
import InvitationCode from "./InvitationCode";
import UserDetails from "./UserDetails";
import FullScreenLoader from "../components/fullScreenLoader";
import CaptchaDialog from "./CaptchaDialog";

const Home = () => {
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [invitationCode, setInvitationCode] = useState("");
  const { isMobile, isTablet } = useScreenDetector();
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [verifiedToken, setVerifiedToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-red-100 to-red-300 flex items-center justify-center p-4 bg-center bg-cover bg-no-repeat relative flex-col"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/background.png`,
      }}
    >
      {loading && <FullScreenLoader />}
      {/* Top Right Button */}
      <div className="flex w-full justify-end mr-0 mb-0 md:mb-8 lg:mb-0 2xl:mr-24">
        <img
          src={`${process.env.PUBLIC_URL}/img/button.png`}
          alt="button"
          className="h-8 xl:h-10 2xl:h-12 2xl:mr-8"
        />
      </div>
      <div className="relative w-full max-w-6xl 2xl:max-w-7xl flex-col md:flex-row flex items-center justify-between">
        {/* Left: Image Section */}
        {isTablet && (
          <div className="w-3/4 md:w-1/2 relative z-10">
            <img
              src={`${process.env.PUBLIC_URL}/img/people.png`}
              alt="people"
              className="w-full h-auto object-contain"
            />
          </div>
        )}
        {/* Right: Code Input Card */}
        <div className=" w-full md:w-1/2 max-w-md pb-4 mb:pb-0 ">
          <div className="mt-8 md:mt-0 mb-8">
            <img
              src={`${process.env.PUBLIC_URL}/img/title.png`}
              alt="titleLogo"
              className="mx-auto h-auto mb-2 w-1/2 md:w-2/3"
            />
          </div>
          <div className="py-2 z-30 relative">
            <img
              src={`${process.env.PUBLIC_URL}/img/banner.png`}
              alt="bannerLogo"
              className="mx-auto h-14 md:h-16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <div className="w-full max-w-md bg-[#E71A22] border-2 border-white rounded-2xl shadow-lg px-6 py-8 md:py-16 text-white relative z-20">
            {/* Right: Code Input Card */}
            {(() => {
              switch (step) {
                case 1:
                  return (
                    <InvitationCode
                      setStep={setStep}
                      setIsOpen={setIsOpen}
                      invitationCode={invitationCode}
                      setInvitationCode={setInvitationCode}
                      loading={loading}
                      setLoading={setLoading}
                    />
                  );
                case 3:
                  return (
                    <UserDetails
                      setStep={setStep}
                      captchaToken={captchaToken}
                      setCaptchaToken={setCaptchaToken}
                      invitationCode={invitationCode}
                      setInvitationCode={setInvitationCode}
                      verifiedToken={verifiedToken}
                      setVerifiedToken={setVerifiedToken}
                      loading={loading}
                      setLoading={setLoading}
                    />
                  );
              }
            })()}
          </div>
        </div>
        {isMobile && (
          <div className="w-full md:w-1/2 relative z-0 p-2 md:p-0">
            <img
              src={`${process.env.PUBLIC_URL}/img/people.png`}
              alt="people"
              className="w-full h-auto object-contain"
            />
          </div>
        )}
      </div>
      <div
        className="absolute bg-cover bg-center bg-no-repeat z-10 w-screen h-1/3 sm:h-2/3 bottom-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/bottom.png`,
        }}
      ></div>
      <CaptchaDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        setStep={setStep}
        captchaToken={captchaToken}
        setCaptchaToken={setCaptchaToken}
        setVerifiedToken={setVerifiedToken}
        setInvitationCode={setInvitationCode}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
};

export default Home;
